function replaceTokens(lang, tokens) {
  if (!lang.code) return lang;

  const token = /{{([A-Z_]+)}}/g;
  const code = lang.code.replace(token, (_, key) => tokens[key]);

  return { ...lang, code };
}

export default function parseData(row, tokens) {
  // replace all mustache variables in the respective code snippets
  const { publish, subscribe } = row.data || {};
  if (!publish || !subscribe) return row;

  return {
    ...row,
    data: {
      publish: publish.map(lang => replaceTokens(lang, tokens)),
      subscribe: subscribe.map(lang => replaceTokens(lang, tokens)),
    },
  };
}
